/**
 * Claim IDs Components
 * A component for displaying and navigating available collection claim IDs
 * Provides a list interface for accessing different collection claim details
 */

import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

/**
 * ClaimIds Component
 * Lists available collections with claim IDs and provides navigation controls
 *
 * Features:
 * - Displays all collections with claim IDs
 * - Navigation to individual collection claim details
 * - Empty state handling
 * - Dynamic configuration loading
 *
 * @returns {JSX.Element} A list interface showing available collection claim IDs
 */
const ClaimIds = () => {
  const navigate = useNavigate();
  const config = useSelector((state) => state.config);
  const [collections, setCollections] = useState([]);

  /**
   * Effect hook to load collections from config
   * Updates collections state when configuration data changes
   */
  useEffect(() => {
    if (config?.clientConfig?.data?.collections) {
      setCollections(config.clientConfig.data.collections);
    }
  }, [config]);

  return (
    <div>
      <div>Salve eccomi</div>
      <div>ecco i claim id:</div>
      {collections.length === 0 && <div>non ci sono</div>}
      {collections.length > 0 &&
        collections.map((collection) => (
          <div key={collection}>
            <button onClick={() => navigate(collection)}>{collection}</button>
          </div>
        ))}
    </div>
  );
};

export default ClaimIds;
